export default {
    dashboardTitle: "mi e-scritorio",
    dashboardSubtitle: "mis 5 últimas Ordenes",
    dashboardProducFrec: "Productos ordenados frecuentemente",
    btnAddToCar: "Agregar Producto",
    btnBack: "Regresar",
    btnOrderAgain: "Ordenar de Nuevo",
    btnMoreOptions: "Opciones",
    btnApprovarOrder: "Aprobar Orden",
    btnCancelOrder: "Anular Orden",
    pedidoTitle: "Orden Nro. ",
    guideTitle: "Guía de Remisión Nro. ",
    invoinceTitle: "Factura Nro. ",
    creditNoteTitle: "Nota de Crédito Nro. ",
    proformaTitle: "Solicitud de Proforma Nro. ",
    ordersHistoryTitle: "Mi Historial",
    opBtnMyOrders: "Mis Ordenes",
    opBtnPendingAprove: "Pendientes de Aprobación",
    opBtnGuies: "Mis Guías de Remisión",
    opBtnInvoices: "Mis Facturas",
    btnSearch: "Buscar",
    menuDashboard: "Mi e-scritorio",
    menuMyAccount: "Mi Cuenta",
    menuQuickOrder: "Orden rápida",
    menuOrderHistory: "Mi Historial",
    btnProcedToCheckout: "Procesar Orden",
    cartTitle: "Mi carrito",
    defaultShoppingCart: "",
    empyCart: "Vaciar Carrito",
    confEmpyCart: "Se eliminarán todos los ítems. ¿Desea continuar?",
    yes: "Si",
    shippingInfo: "Información de Entrega",
    shippingAddress: "Dirección de Entrega",
    shippingPhone: "Teléfono de Entrega",
    shippingCity: "Ciudad de Entrega",
    orderInfo: "Información de la Orden",
    orderPurchaseNumber: "Nro Orden de Compra",
    orderPurchaseLogistic: "Logística, Contacto y Horario de Entrega",
    reviewOrder: "Verificar Orden",
    btnModifOrder: "Modificar Orden",
    paymentInfo: "Condiciones de Pago",
    salesCondition: "Términos y condiciones",
    aggreCondition: "He leído y acepto los Términos y Condiciones",
    btnConfirOrder: "Confirmar mi Orden",
    confirmTitle1: "Su Orden de Compra ha sido procesado correctamente.",
    confirmTitle2: "Su Orden de Compra se encuentra pendiente de aprobación.",
    thankYouForInterest: "Agradecemos su interés",
    emailConfirmationNotice1: "Se enviará una confirmación a su correo electrónico.",
    emailConfirmationNotice2: "Su Orden de Compra se encuentra Pendiente de Aprobación del Supervisor.",
    webOrderNumberLabel: "Su número de Orden es",
    orderApproved1: "Orden Aprobada",
    orderApproved2: "En espera de Aprobación del Supervisor",
    orderDate: "Fecha de Orden",
    questionsOrComments: "Si tiene dudas o comentarios, no dude en contactarnos.",
    continueShopping: "Realizar otra Orden",
    printPaymentReceipt: "Imprimir comprobante",
    allProducts: "Todos los productos",
    aproveeTitle: "¿Está seguro de que desea aprobar esta Orden?",
    aproveeText: "Una vez aprobado, esta acción no se puede deshacer.",
    yesAprovee: "Si, aprobar",
    approveSuccessTitle: "¡Orden aprobada!",
    approveSuccessTimePrefix: "Ud. Cuenta con",
    approveSuccessTimeSuffix: "para anular esta orden.",
    dayLabelSingular: "día",
    dayLabelPlural: "días",
    hourLabelSingular: "hora",
    hourLabelPlural: "horas",
    understood: "Entendido",
    cancel: "Cancelar",
    cancelOrderTitle: "¿Está seguro de que desea anular esta Orden?",
    cancelOrderText: "Una vez anulada, esta acción no se puede deshacer.",
    cancelOrderExpired: "El plazo para anular esta orden ha vencido.",
    cancelOrderReasonPlaceholder: "Ingrese el motivo de la anulación...",
    yesCancelOrder: "Si, anular",
    btnGenerarOrden: "Generar Orden de Compra",
    btnApproveProforma: "Aprobar Proforma",
    approveProformaTitle: "¿Está seguro/a que desea Aprobar esta Proforma?",
    approveProformaText: "Una vez aprobada, esta acción no se puede deshacer.",
    menuDocumentsReceived: "Documentos electrónicos recibidos",
    menuCxP: "Cuentas por Pagar",
    menuOthersDocumentsReceived: "Guías de remisión recibidas",
    orderStatusTitle: "Seguimiento de la Orden",
    orderStatusPending: "Aún pendiente",
    status_EC_HECHO_label: "Orden Creada",
    status_EC_HECHO_desc: "La orden fue creada.",
    status_EC_APROBADO_label: "Aprobado",
    status_EC_APROBADO_desc: "La orden fue aprobada.",
    status_ULTRA_RECIBIDO_label: "Recibido",
    status_ULTRA_RECIBIDO_desc: "La orden fue recibida para procesarla.",
    status_ULTRA_GUIA_EMITIDA_label: "Guía Emitida",
    status_ULTRA_GUIA_EMITIDA_desc: "Se emitió la guía de remisión de la orden.",
    status_ULTRA_EN_RUTA_label: "En Ruta",
    status_ULTRA_EN_RUTA_desc: "La guía fue despachada y se encuentra en ruta.",
    status_EC_ENTREGADO_label: "Entregado",
    status_EC_ENTREGADO_desc: "La mercadería fue recibida en bodega.",
    status_ULTRA_FACTURADO_label: "Facturado",
    status_ULTRA_FACTURADO_desc: "La orden fue facturada al cliente.",
    lblConditionSerec: "Debo y pagaré sin condiciones, a la orden de SEREC CIA.LTDA. El valor de esta orden, por concepto de los productos que aquí se detallan recibidos. \n" +
        "Favor cancelar a nombre de SEREC CIA.LTDA. mediante depósito o transferencia bancaria a la CUENTA CORRIENTE No.3045742304 del BANCO PICHINCHA o CUENTA CORRIENTE No.5005053109 BANCO BOLIVARIANO.\n" +
        "Confirmar el pago al email documentos@serec-ecuador.com después de la fecha de vencimiento no se aceptan reclamos sobre el contenido de la presente orden.\n" +
        "Por favor emitir y enviar el comprobante de retención al correo documentos@serec-ecuador.com dentro de los 5 días emitida la factura de acuerdo a la ley " +
        "ART.No.39LRT NO SE RECIBIRÁN RETENCIONES PASADO ESTE TIEMPO."
};
